var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-title',{attrs:{"size":"text-body-1","space":"4","title":"OUR PROMISE","weight":"regular"}}),_c('base-body',[_vm._v(" We are committed to providing superior solutions to our clients-from start-ups to large corporations, and everything in between. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }